import React, { Component, Fragment } from 'react'
import { Grid, withStyles, CircularProgress } from "@material-ui/core";
import MenuItem from './MenuItem'
import firebase from '../../firebase'
import CreateItem from './CreateItem'

const styles = theme => ({
    paper: {
        padding: 16,
        margin: theme.spacing(2),
        // height: '100%',
        overflowY: 'auto'
    },
    root: {
        width: '100%',
        maxWidth: 360,
        backgroundColor: theme.palette.background.paper,
    },
    nested: {
        paddingLeft: theme.spacing(4),
    },
})

class Category extends Component{

    constructor(props) {
        super(props)

        this.state = {
            items: [],
            name: "",
            loading: true
        }

        // this.deleteNote = this.deleteNote.bind(this)
        // this.addNote = this.addNote.bind(this)

        this.database = firebase.database().ref().child('categories')
    }
    componentDidMount() {
        const prevItems = this.state.items

        this.database.on('child_added', snap => {
            prevItems.unshift({
                id: snap.key,
                name: snap.val().name,
                time: snap.val().time,
                imageUrl: snap.val().imageUrl,
                visible: snap.val().visible,
            })

            this.setState({
                loading: false,
                items: prevItems
            })
        })

        this.database.on('child_removed', snap => {
            for (var i = 0; i < prevItems.length; i++) {
                if (prevItems[i].id === snap.key) {
                    prevItems.splice(i, 1);
                    break;
                }
            }

            this.setState({
                items: prevItems
            })

        })

        this.database.on('child_changed', snap => {

            for (var i = 0; i < prevItems.length; i++) {
                if (prevItems[i].id === snap.key) {
                    prevItems[i]["name"] = snap.val().name;
                    prevItems[i]["time"] = snap.val().time;
                    prevItems[i]["imageUrl"] = snap.val().imageUrl;
                    prevItems[i]["visible"] = snap.val().visible;
                    break;
                }
            }

            this.setState({
                items: prevItems
            })

            this.forceUpdate()

        })

    }

    getitemsByCategory() {
        return Object.entries(this.state.items.reduce((items, item) => {
            const { category } = item
            items[category] = items[category] ? [...items[category], item] : [item]

            return items
        }, {})
        )
    }

    getCategories() {
        return Object.values(this.state.items.reduce((items, item) => {
            const { category } = item
            items[category] = {title: category}
            return items
        }, {})
        )
    }

    handleItemClick = (item) => {
        console.log(item)
        this.setState({
            name: item.name
        })
    }

    handleDeleteItemClick = (itemId) => {
        this.database.child(itemId).remove().then(
            console.log("successfully deleted")
        ).catch(
            console.log("error in deleting")
        )
    }

    handleVisibleItemClick = (itemId, hide) => {
        this.database.child(itemId).child("visible").set(!hide);
    }


    render() {
        const { classes } = this.props
        const { items } = this.state
        return (
            <Fragment>
                {this.state.loading ? < CircularProgress style={{ position: "fixed", top: "50%", left: "50%" }}></CircularProgress> : <></>}
                {/* <Header addButton={<CreateItem color="inherit" categories={categories} className={classes.menuButton} />}></Header> */}
            <Grid container justify="center" spacing={4} style={{ marginTop: 6 }}>
                {items.map((item) => {
                    // console.log(group)
                    return (
                        <MenuItem item={item} key={item.key} handleItemClick={this.handleItemClick} handleDeleteItemClick={this.handleDeleteItemClick} handleVisibleItemClick={this.handleVisibleItemClick}></MenuItem>
                    )
                        // <Note noteContent={note.noteContent} noteID={note.id} deleteNote={this.deleteNote} key={note.id}></Note>
                    })
                }
            </Grid>
            <CreateItem color="inherit" className={classes.menuButton} />
            </Fragment>
        )
    }
}

export default withStyles(styles)(Category)









